<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:budgetModal="{}"
        >
          <i class="far fa-plus"></i> T&amp;M Project
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Time &amp; Materials</h2>

      <budgets-list-filters v-model="params" />

      <c-data-list :items="budgets" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-5">
            <p>Project</p>
          </div>
          <div class="col-4 col-lg-2">
            <p>Balance</p>
          </div>
          <div class="col-4 col-lg-2">
            <p>Budget</p>
          </div>
          <div class="col-4 col-lg-2">
            <p>Spent</p>
          </div>
          <div class="col-12 col-lg-1 text-end">
            <p>Status</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <budgets-list-item :budget="slotProps.item" />
        </template>
        <template v-slot:empty>
          No time &amp; materials projects to show.
        </template>
      </c-data-list>
    </div>

    <budget-modal
      ref="budgetModal"
      title="Create Time & Material Project"
      :budget="newBudget"
      @created="budgetCreated"
    />
    <client-create-modal
      ref="clientModal"
      title="Create Client"
      :client="{}"
      mode="create"
    />
    <contact-create-modal
      ref="contactModal"
      title="Create Contact"
      :contact="{}"
    />
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import { mapState, mapActions } from 'vuex'
import BudgetsListItem from './BudgetsListItem'
import BudgetsListFilters from './BudgetsListFilters'
import BudgetModal from './BudgetModal'
import ClientCreateModal from 'components/clients/ClientCreateModal'
import ContactCreateModal from 'components/clients/client/ContactCreateModal'
import BudgetModel from './../../models/budget.js'

export default {
  components: {
    BudgetsListItem,
    BudgetsListFilters,
    BudgetModal,
    ClientCreateModal,
    ContactCreateModal
  },

  data () {
    return {
      params: {},
      newBudget: new BudgetModel()
    }
  },

  mounted () {
    this.getBudgets(this.params)

    this.$watch('params', async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return
      }

      await this.getBudgets(params)
    })
  },

  computed: {
    ...mapState('budget', { budgets: 'list' })
  },

  methods: {
    ...mapActions('budget', { getBudgets: 'getList', getBudgetsForNextPage: 'getListForNextPage' }),

    async loadNextPage (done) {
      try {
        await this.getBudgetsForNextPage(this.params)

        done()
      } catch (error) {
        done(true)
      }
    },

    budgetCreated (budget) {
      this.$router.push({ name: 'budgets.overview', params: { budget_id: budget.id } })
    }
  }
}
</script>
